<h2 mat-dialog-title mat-dialog-draggable-title>{{'title.update_department' | translate}}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onClickBtnCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>
  <form #f="ngForm" (ngSubmit)="f.form.valid && onCreateGroup()" [appCheckCode]="['code']"
  appFocusFirstElement
    appFocusFirstElement style="margin-top: 10px;">
    <mat-dialog-content>
          <div class="row">
            <!-- code -->
            <div class="col-sm-6">
              <mat-form-field class="mat-full-width">
                <input (focusout)="userGroup.code = userGroup.code.trim()" #focusInput autocomplete="off" id="code"
                  matInput [placeholder]="'search_form.department_code' | translate" type="text" name="code"
                  [(ngModel)]="userGroup.code" #code="ngModel" [ngClass]="{ 'is-invalid': f.submitted || code.invalid }"
                  required maxlength="200" />
                <button mat-button *ngIf="userGroup.code" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="userGroup.code=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || code.invalid">
                  <span class="text-error" *ngIf="code?.errors?.required">
                    {{'validation.department_code_requied' | translate}}
                  </span>
                  <span class="text-error" *ngIf="code?.errors?.validIp">
                    {{'validation.code_format' | translate}}
                  </span>
                </mat-error>
                <mat-error *ngIf="code?.errors?.duplicate">
                  {{ 'validation.err_department_code_duplicate' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <!-- Phân loại -->
            <div class="col-sm-6">
              <div>
                <mat-form-field>
                  <mat-label>{{'search_form.department_type' | translate}}</mat-label>
                  <mat-select #departmentTypeSelect (focusout)="(checkFocus = true)"
                              (focus)="commonService.openComboBox(checkFocus, departmentTypeSelect)" id="departmentType"
                              [(ngModel)]="userGroup.departmentType"
                              (selectionChange)="checkFocus = false;"
                              #departmentType="ngModel"
                              required
                              name="departmentType">
                    <mat-option [value]="1" (click)="this.commonService.closeDropdownList(this.departmentTypeSelect)">
                      {{ 'form.department' | translate }}
                    </mat-option>
                    <mat-option [value]="2" (click)="this.commonService.closeDropdownList(this.departmentTypeSelect)">
                      {{ 'form.branch' | translate }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="f.submitted || departmentType.invalid">
              <span class="text-error" *ngIf="departmentType?.errors?.required">
                {{'validation.department_type_required' | translate}}
              </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <!-- Name -->
            <div class="col-sm-12">
                <mat-form-field class="mat-full-width">
                  <input (focusout)="userGroup.name = userGroup.name.trim()" #focusInput autocomplete="off" id="name"
                    matInput [placeholder]="'search_form.department_name' | translate" type="text" name="name"
                    [(ngModel)]="userGroup.name" #name="ngModel" [ngClass]="{ 'is-invalid': f.submitted || name.invalid }"
                    required maxlength="200" />
                  <button mat-button *ngIf="userGroup.name" type="button" matSuffix mat-icon-button aria-label="Clear"
                    (click)="userGroup.name=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted || name.invalid">
                    <span class="text-error" *ngIf="name?.errors?.required">
                      {{'validation.department_name_requied' | translate}}
                    </span>
                  </mat-error>
                  <mat-error *ngIf="name?.errors?.duplicate">
                    {{ 'validation.err_department_name_duplicate' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>


              <!-- Mô tả -->
              <div class="col-sm-12">
                <mat-form-field class="mat-full-width">
                  <textarea (focusout)="userGroup.description = userGroup.description.trim()" type="text" matInput
                    [placeholder]="'search_form.department_description' | translate" rows="2" name="description" id="description"
                    [(ngModel)]="userGroup.description" maxlength="500"></textarea>
                </mat-form-field>
              </div>
          </div>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <!-- Huỷ bỏ & Lưu -->
    <mat-dialog-actions align="center">
      <button mat-stroked-button color="primary" class="mr-3" (click)="onClickBtnCancel()" type="button">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.cancel' | translate}}
      </button>
      <button mat-raised-button [disabled]="(!isFormChanging && !change) || !userGroup.name || !userGroup.code || code.invalid" type="submit" cdkFocusInitial color="primary">
        <mat-icon class="mr-0">save</mat-icon>
        {{'button.update_department' | translate}}
      </button>
    </mat-dialog-actions>
  </form>
